export const connectedNetwork = "ghostnet";
export const rpcNode = "https://ghostnet.smartpy.io";


export const NCUCoin = "KT1AefyQpVfjupNFKBoKqrVHtHnCSZ7AKBtX";
export const Canteen = "KT1U9UymqqwGA8McTZ63UFJAKugTbPbLQDfA";
export const FoodNFT = "KT1FpJPYLKVZDW11NCYZUbdZQGSugAdPqKcX";
export const AchievementNFT = "KT1KU4krNtEbiapDXvjMzL4YJ1WXiMF8MHFy";
export const NcuCoinDistributor = "KT1LZ83BTJVhaakmS7G51KfCeKZy663PRrLg";